'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').service('historySvc', historySvc);

  historySvc.$inject = ['httpSvc', '$filter', 'moodTrackerSvc', 'moodTrackerDataMappingSvc'];

  /* @ngInject */
  function historySvc(httpSvc, $filter, moodTrackerSvc, moodTrackerDataMappingSvc) {
    return {
      getCurrent: getCurrent,
      getRecent: getRecent,
      getWeekly: getWeekly,
      getMonthly: getMonthly,
      getNext: getNext,
      getHelpfulActivities: getHelpfulActivities,
      getMoodCheckins: getMoodCheckins
    };

    ////////////////
    function getCurrent() {
      return httpSvc.get('/apiproxy/user/history/current');
    }

    function getRecent() {
      return httpSvc.get('/apiproxy/user/history/daily');
    }

    function getWeekly() {
      return httpSvc.get('/apiproxy/user/history/weekly');
    }

    function getMonthly() {
      return httpSvc.get('/apiproxy/user/history/monthly');
    }

    function getNext(dateFrom) {
      return httpSvc.get('/apiproxy/user/history/daily?context=CORE' + (dateFrom !== null ? '&dateFrom=' + dateFrom : '')).then(function (data) {
        _.map(data, function (session) {
          if (!_.isEmpty(session.mood)) {
            session.mood.newScaleMood = $filter('oldScaleToNewScale')(session.mood.mood);
            session.mood.buttonIndex = $filter('trackerValueToButtonIndex')(session.mood.newScaleMood);
          }
        });
        return data;
      });
    }

    function getHelpfulActivities(dateFrom, dateTo) {
      return httpSvc.get('/apiproxy/user/history/helpful?since=' + dateFrom + '&until=' + dateTo).then(function (resp) {
        resp.all = resp.favorite.concat(resp.helpful);
        // remove duplicates
        var found = {};
        resp.all = resp.all.filter(function (a) {

          // Map properties to common property names.
          // TODO: normalize these properties in the API, then remove this code.
          a.id = a.activityId;
          a.title = a.activityTitle;
          a.description = a.activityDescription;
          a.url = a.activityUrl;

          // Inspiration Specific Properties
          a.userAlias = a.activityTitle;

          return found.hasOwnProperty(a.activityUrl) ? false : found[a.activityUrl] = true;
        });

        resp.favoritedInspirations = resp.all.filter(function (a) {
          return !a.activityType.normal;
        });
        resp.favoritedActivities = resp.all.filter(function (a) {
          return a.activityType.normal;
        });

        return resp;
      });
    }

    function getMoodCheckins(dateFrom, dateTo, trackerId) {
      // increase the date range requested to account for time zone differences.
      return httpSvc.get('/apiproxy/user/tracker/moods?id=' + trackerId + '&startDate=' + dateFrom.clone().subtract(1, 'day').format('YYYY-MM-DD') + '&endDate=' + dateTo.clone().add(1, 'day').format('YYYY-MM-DD')).then(function (result) {
        // Filter out the entries that aren't within the requested range, relative to this time zone.
        var resultData = result[0];
        resultData.trackerEntries = moodTrackerDataMappingSvc.filterForDateRange(resultData.trackerEntries, dateFrom, dateTo);
        return resultData;
      });
    }
  }
})();